import { OneTeaserMode } from '@sccs/types';
import { DlsAlternative } from '../../http/clients/dls/DlsClientAlternative';
import { DlsSearch } from '../../http/clients/dls/DlsClientSearch';
import { DlsTeaser } from '../../http/clients/dls/DlsClientTeaser';
import { vehicleAssortmentPrivate } from '../VansCompatMap';
import { createVanConfiguration } from '../VansConfiguration';

export function getRequestConfiguration(
  isCommercialVan: boolean,
  parameter: DlsSearch | DlsTeaser | DlsAlternative,
  mode?: string,
) {
  const { filterCriteria, ...rest } = parameter;
  if (isCommercialVan) {
    const vansConfig = createVanConfiguration(filterCriteria);
    if ('vehicleAssortment' in vansConfig) {
      return {
        clusteringCriteria: vansConfig.clusteringCriteria,
        vehicleAssortment: vansConfig.vehicleAssortment,
        ctx: rest.ctx,
      };
    } else {
      throw new Error('Invalid van configuration: vehicleAssortment is missing');
    }
  }
  if (isDlsTeaser(parameter)) {
    const clusteringCriteria =
      mode === OneTeaserMode.HOMEPAGE_CARS ? ['PRICE', 'COLOR_GROUP', 'POWER', 'LINE'] : ['PRICE'];
    return {
      clusteringCriteria,
      vehicleAssortment: vehicleAssortmentPrivate,
      ctx: rest.ctx,
    };
  }
  return {
    vehicleAssortment: vehicleAssortmentPrivate,
    ctx: rest.ctx,
  };
}

export function isDlsTeaser(parameter: DlsSearch | DlsTeaser | DlsAlternative): parameter is DlsTeaser {
  return !('includeFirstVehicles' in parameter);
}
